import React, { useState, useEffect } from "react";
// import "./Dashboard.css";

interface Campaign {
  id: number;
  campaign_name: string;
}

interface MetricsData {
  id: number | string;
  date: string;
  visitors: string | number;
  bid_requests: string | number;
  cost: string | number;
}

const AdminPannelPage: React.FC = () => {
  const [campaigns, setCampaigns] = useState<Campaign[]>([]);
  const [currentMetricsData, setCurrentMetricsData] = useState<MetricsData>({
    id: "",
    date: "",
    visitors: "",
    bid_requests: "",
    cost: "",
  });
  const [isMetricsModalOpen, setIsMetricsModalOpen] = useState(false);

  useEffect(() => {
    fetchCampaigns();
  }, []);

  // Fetch campaigns from the server
  const fetchCampaigns = async () => {
    try {
      const response = await fetch("https://bidvertiser-api.vercel.app/api/alldata");
      const data = await response.json();
      setCampaigns(data.campaigns);
    } catch (error) {
      console.error("Error fetching campaigns:", error);
    }
  };

  // Open the modal to insert daily metrics
  const handleMetricsModalOpen = (campaignId: number) => {
    setCurrentMetricsData({
      id: campaignId,
      date: "",
      visitors: "",
      bid_requests: "",
      cost: "",
    });
    setIsMetricsModalOpen(true);
  };

  // Handle input changes in the modal form
  const handleMetricsChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    setCurrentMetricsData({
      ...currentMetricsData,
      [e.target.name]: e.target.value,
    });
  };

  // Submit the daily metrics data to the backend
  const handleMetricsSubmit = async () => {
    try {
      const baseUrl = window.location.hostname === 'localhost'
      ? `http://localhost:5000/api/metrics/insertDailyMetrics`
      : `https://bidvertiser-api.vercel.app/api/metrics/insertDailyMetrics`;

    // Construct the API URL with the date range query parameters
    const apiUrl = `${baseUrl}`;

      const response = await fetch(`${baseUrl}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(currentMetricsData),
      });

      if (response.ok) {
        alert("Metrics inserted successfully!");
        setIsMetricsModalOpen(false);
        fetchCampaigns(); // Refresh the campaigns list
      } else {
        const result = await response.json();
        throw new Error(result.message || "Failed to insert metrics");
      }
    } catch (error) {
      console.error("Error inserting metrics:", error);
      alert("Error inserting metrics.");
    }
  };

  return (
    <div className="dashboard">
      <h1>Campaigns Dashboard</h1>
      <table className="campaign-table">
        <thead>
          <tr>
            <th>ID</th>
            <th>Campaign Name</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {campaigns.map((campaign) => (
            <tr key={campaign.id}>
              <td>{campaign.id}</td>
              <td>{campaign.campaign_name}</td>
              <td>
                <button onClick={() => handleMetricsModalOpen(campaign.id)} className="btn btn-primary">
                  Insert Daily Metrics
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {isMetricsModalOpen && (
        <div className="modal">
          <div className="modal-content">
            <h2>Insert Daily Metrics</h2>
            <form>
              <label>Campaign ID:</label>
              <input
                type="text"
                name="id"
                value={currentMetricsData.id}
                readOnly
                className="input-field"
              />
              <label>Date:</label>
              <input
                type="date"
                name="date"
                onChange={handleMetricsChange}
                value={currentMetricsData.date}
                className="input-field"
              />
              <label>Visitors:</label>
              <input
                type="number"
                name="visitors"
                onChange={handleMetricsChange}
                value={currentMetricsData.visitors}
                className="input-field"
              />
              <label>Bid Requests:</label>
              <input
                type="number"
                name="bid_requests"
                onChange={handleMetricsChange}
                value={currentMetricsData.bid_requests}
                className="input-field"
              />
              <label>Cost:</label>
              <input
                type="number"
                step="0.01"
                name="cost"
                onChange={handleMetricsChange}
                value={currentMetricsData.cost}
                className="input-field"
              />
            </form>
            <button onClick={handleMetricsSubmit} className="btn btn-save">
              Insert
            </button>
            <button onClick={() => setIsMetricsModalOpen(false)} className="btn btn-cancel">
              Cancel
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminPannelPage;
